import { createSelector } from 'reselect';

import { assignedEventsSelector, visibleEventsSelector } from '../redux/events';
import { standardCrewsSelector } from '../redux/standardCrews';
import { matchCrews } from '../utils';




function sortEquipment(a, b) {
  return sortEquipmentByDisplayOrder(a, b) || sortEquipmentByName(a, b);
}

function sortEquipmentByDisplayOrder(a, b) {
  if (a == null || b == null || !a.displayOrder || !b.displayOrder) {
    return 0;
  } else if (typeof(a.displayOrder) !== 'number') {
    return -1;
  } else if (typeof(b.displayOrder) !== 'number') {
    return 1;
  } else {
    return a.displayOrder - b.displayOrder;
  }
}

function sortEquipmentByName(a, b) {
  if(a && b)
  {
  return a.name < b.name
    ? 1
    : a.name > b.name
      ? -1
      : 0;
  }
  return -1;
}

function matchEquipment(a,b)
{
    if (!a && !b) {
        return true;
      }
      else if (a && b && a.id === b.id){
        return true;}
      else if (!a || !b) {
        return false;}
}



/**
 * Determines the largest subset of offices common to all resources on a specified crew.
 *
 * @param {any} crew
 * @returns Array of common offices
 */
function maximalOfficeSet(crew) {
  return crew.resources
    .filter(r => !!r.resource)
    .map(r => r.resource.offices)
    .reduce((prev, curr) => {
      if (!prev) {
        return curr;
      } else {
        return prev.filter(o => curr.some(o2 => o2.id === o.id));
      }
    }, null) || [];
}

function getFilteredCrew(crew, offices)
{
  const filteredCrews = offices.length > 0
        ?offices.some((o) => o.id === crew.office.id)
        : null;
        return filteredCrews;
}

export default (includeUnassigned) => { 

  const visibleEvents = createSelector(
    includeUnassigned ? visibleEventsSelector : assignedEventsSelector,
    events => events.map(e => ({
      ...e,
      crew: e.crew ? {
        ...e.crew,
        offices: maximalOfficeSet(e.crew)
      } : null
    }))
  );
   
  
  return createSelector(
    visibleEvents,
    state => state.equipments.equipment,
    state => state.calendar.activeEquipment,
    state => state.calendar.selected_employees,    
    (events, equipment, activeEquipment,selected_employees) =>  
    events.reduce(
    (eqs,evt) =>
    {      
      let crew = evt.crew;//?getFilteredCrew(evt.crew,offices):null;
      let eq = eqs?eqs.find((e) => matchEquipment(e.equipment, crew?crew.equipment:null)):null; 
      if(!eq)
      {
          eq = {
          active: !!activeEquipment &&  evt.equipment?(activeEquipment.id === evt.equipment.id):false,
          equipment: crew? crew.equipment:null,
          
          events:[]
          }
        
      eqs.push(eq);
      }
      if(selected_employees.length > 0 ) // If Employee selected then show his events only
      {
        let res = crew?crew.resources.find( (rs) => selected_employees.indexOf(rs.resource != null ? rs.resource.id : 0) >= 0) : null;
        if(res)
          eq.events.push(evt);
        
      }
      else
      {
        //console.log(evt);
        eq.events.push(evt);
  
      }
      
      return eqs;
    }
    ,
    [{ active: !activeEquipment,  equipment: null,  events: [] },
    ...equipment.map( e =>
    ({
    active: !!activeEquipment && activeEquipment.id === e.id,
    equipment: e,    
    events:[]
    })
    )]
    ).sort((a, b) =>{ sortEquipment(a.equipment, b.equipment)})      
  )
};
